import React, { useEffect, useState } from 'react';
import Panel from '../Panel';
import LoaderButton from '../LoaderButton';
import LoadingBlinker from '../LoadingBlinker';
import OAuthAPI from '../../lib/OAuthAPI';
import OAuthErrorNotice from './OAuthErrorNotice';
import OAuthSignIn from './OAuthSignIn';

function OAuthAuthorizedApps() {
	let [state, setState] = useState('loading');
	let [grants, setGrants] = useState([]);
	let [error, setError] = useState(null);
	let [revoking, setRevoking] = useState(null);
	let load = () => {
		setState('loading');
		// Do not retain the expected pre-sign-in 401 after a successful hosted
		// session is established and this view is loaded again.
		setError(null);
		OAuthAPI.getGrants().then(result => { setGrants(result.grants || []); setState('ready'); }).catch(requestError => {
			setState(requestError.response && requestError.response.status === 401 ? 'sign-in' : 'error'); setError(requestError);
		});
	};
	useEffect(load, []);
	let revoke = async grant => {
		if(!window.confirm(`Revoke ${grant.client ? grant.client.Name : 'this app'}? It will lose access immediately.`)) return;
		setRevoking(grant.Id); setError(null);
		try { await OAuthAPI.revokeGrant(grant.Id); setGrants(previous => previous.filter(item => item.Id !== grant.Id)); }
		catch (requestError) { setError(requestError); } finally { setRevoking(null); }
	};
	if(state === 'loading') return <Panel className="oauth-panel"><LoadingBlinker text="Loading authorized apps" /></Panel>;
	if(state === 'sign-in') return <Panel className="oauth-panel"><OAuthSignIn onSignedIn={load} /></Panel>;
	if(state === 'error') return <Panel className="oauth-panel"><h2>Authorized apps unavailable</h2><OAuthErrorNotice error={error} fallback="We could not load your authorized apps." /></Panel>;
	return <Panel className="oauth-panel"><h2>Authorized apps</h2><p>Revoking access immediately disables the app's access and refresh tokens for this sport.</p>
		{grants.length ? grants.map(grant => <div className="oauth-client-card" key={grant.Id}><h3>{grant.client ? grant.client.Name : 'Deleted app'}</h3><p><strong>Sport:</strong> {grant.Sport} · <strong>Scopes:</strong> {(grant.Scopes || []).join(', ')}</p><p>Authorized {new Date(grant.CreatedAt).toLocaleString()}</p><LoaderButton className="loader-button oauth-deny" isLoading={revoking === grant.Id} disabled={Boolean(revoking)} onClick={() => revoke(grant)}>Revoke access</LoaderButton></div>) : <p>No third-party apps currently have access.</p>}
		{error ? <OAuthErrorNotice error={error} fallback="We could not complete that revocation." /> : null}
	</Panel>;
}

export default OAuthAuthorizedApps;
